import React from 'react';
import PropTypes from 'prop-types';
import './style.css';
import PolledTrackingContainer from "../PolledTrackingContainer";
import WindowFocus from "../WindowFocus";
import { ClickstreamContext } from '../../providers/Clickstream.provider';

export default class App extends React.Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
  };
  static contextType = ClickstreamContext;

  componentDidMount() {
    const clickstream = this.context;
    if (clickstream) {
      clickstream.track({
        eventName: "Website Opened",
        baseMapLoad: {
          tripId: this.props.token,
        }
      });
    }
  }

  render() {
    return (
      <div className="App">
        <WindowFocus>
          <PolledTrackingContainer token={this.props.token} interval={6000}/>
        </WindowFocus>
      </div>
    );
  }
}
